import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({
  items,
  tone = "default",
}: {
  items: Crumb[];
  tone?: "default" | "light";
}) {
  const base = tone === "light" ? "text-background-50/70" : "text-foreground-500";
  const linkColor =
    tone === "light" ? "hover:text-background-50" : "hover:text-primary-600";
  const currentColor = tone === "light" ? "text-background-50 font-medium" : "text-foreground-800 font-medium";
  const sepColor = tone === "light" ? "text-background-50/40" : "text-foreground-300";

  return (
    <nav className={`flex items-center flex-wrap gap-2 text-sm ${base}`} aria-label="面包屑导航">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className={`${linkColor} transition-colors cursor-pointer`}>
              {item.label}
            </Link>
          ) : (
            <span className={currentColor}>{item.label}</span>
          )}
          {idx < items.length - 1 && <i className={`ri-arrow-right-s-line ${sepColor}`}></i>}
        </span>
      ))}
    </nav>
  );
}